export default "__VITE_ASSET__DHnES_w___"